import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import {
  BORDER,
  COLOR_GREY_5,
  COLOR_GREY_8,
  COLOR_GREY_12,
} from "shared/theme/colors";
import { flex } from "shared/theme/mixins";

export const StyledContainer = styled(Box)`
  ${flex({ ai: "flex-start" })};
  width: calc(100% - 3rem);
  border-radius: 0.5rem;
  margin: 0 1.5rem;
  padding: 0.75rem;
  border: ${BORDER(1, COLOR_GREY_5)};
  min-height: 104px;
  box-sizing: border-box;
  position: sticky;
  bottom: 0;
  margin-top: 1rem;
`;

export const StyledButtonContainer = styled(Box)`
  ${flex({ ai: "end" })};
  min-height: 100%;
`;

export const StyledTextField = styled(TextField)`
  width: 100%;
  overflow-y: hidden;
  flex-grow: 1;
  height: 100%;

  .MuiOutlinedInput-root {
    ${flex({ ai: "flex-start" })};
    padding: 0;
    height: 100%;

    .MuiOutlinedInput-input {
      padding: 0;
      font-size: 14px;
      color: ${COLOR_GREY_12};
      border: none;

      ::placeholder {
        color: ${COLOR_GREY_8};
        opacity: 1;
      }
    }

    .MuiOutlinedInput-notchedOutline {
      border: none;
    }
  }
`;
